import { MUTATION_KEYS, QUERY_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { UsersService } from 'services/users';

export const useBanAdmin = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return useMutation({
    mutationKey: [MUTATION_KEYS.BAN_ADMIN],
    mutationFn: async (userId: string) => {
      await UsersService.banUser(userId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ADMINS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ADMINS_COUNT] });
      toast.success(t('InsuranceAdministrators.banAdmin.success'));
      hideDialog();
    },
    onError: () => {
      toast.error(t('InsuranceAdministrators.banAdmin.error'));
    },
  });
};
